<div *ngIf="!has_error">
	<div class="configure-container" [ngClass]="{ 'has-fixed-footer': has_fixed_footer }">
		<div class="configure">
			<!--  DEALER HEADER  -->

			<ui-dealer-header
				[callback_enabled]="mode === 'enquiry' && !full_payment_made"
				[quote_ref]="registration"
				[location]="'engage_configure'"
			></ui-dealer-header>

			<!--  END DEALER HEADER  -->

			<!--  ROUTER OUTLET  -->

			<router-outlet></router-outlet>

			<!--  END ROUTER OUTLET  -->

			<!--  SMALL PRINT  -->

			<div class="footer">
				<ui-customer-support
					[callback_enabled]="mode === 'enquiry' && !full_payment_made"
					[quote_ref]="registration"
					[location]="'engage_configure'"
				></ui-customer-support>
				<div class="container written-content small-print">
					<p *ngIf="dealer.custom_footer_text">{{ dealer.custom_footer_text }}</p>
					<p *ngIf="!dealer.custom_footer_text">
						{{ dealer.friendly_name }} is authorised and regulated by the Financial Conduct Authority, FRN:
						{{ dealer.fca_number || '' }}. All finance is subject to status and income. Written Quotation on
						request. We act as a credit broker not a lender. We work with a number of carefully selected
						credit providers who may be able to offer you finance for your purchase. We are only able to
						offer finance products from these providers.
					</p>
					<p>
						<a [routerLink]="['/configure/terms-of-use']" target="_blank">Terms of Use</a>
						|
						<a [routerLink]="['/configure/privacy-policy']" target="_blank">Privacy Policy</a>
						|
						<a [routerLink]="['/configure/cookie-policy']" target="_blank">Cookie Policy</a>
					</p>
				</div>
				<ui-trust-logos [location]="'engage_configure_footer'"></ui-trust-logos>
			</div>

			<!--  END SMALL PRINT  -->
		</div>
	</div>
</div>

<cng-consent></cng-consent>
